export default __webpack_public_path__ + "static/media/myEvents.3c266124.svg";